import { Box } from '@mui/material';
import { Coords } from './coords';

export const PlantMarker = (props: Coords & { onClick: () => void }) => (
  <Box
    onClick={props.onClick}
    sx={{
      cursor: 'pointer',
      position: 'absolute',
      transform: 'translate(-50%, -50%)',
    }}
  >
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
      <g filter="url(#filter0_ddd_12584_35655)">
        <rect
          x="6"
          y="33.6523"
          width="28.8464"
          height="28.8464"
          rx="14.4232"
          transform="rotate(-90 6 33.6523)"
          fill="#29314F"
        />
        <rect
          x="5.59936"
          y="34.053"
          width="29.6477"
          height="29.6477"
          rx="14.8239"
          transform="rotate(-90 5.59936 34.053)"
          stroke="white"
          strokeWidth="0.80129"
        />
      </g>
      <g clipPath="url(#clip0_12584_35655)">
        <path
          d="M25.2669 17.0933C25.4512 17.1245 25.6249 17.1575 25.7877 17.192V16.9873H25.8882C25.9755 16.9873 26.0462 16.9578 26.0462 16.9214V16.9077C26.0462 16.8713 25.9755 16.8419 25.8882 16.8419H25.7877V16.4246H25.8882C25.9755 16.4246 26.0462 16.3951 26.0462 16.3587V16.3451C26.0462 16.3087 25.9755 16.2792 25.8882 16.2792H25.7877V15.8619H25.8882C25.9755 15.8619 26.0462 15.8324 26.0462 15.796V15.7824C26.0462 15.746 25.9755 15.7165 25.8882 15.7165H25.7877V15.2992H25.8882C25.9755 15.2992 26.0462 15.2697 26.0462 15.2333V15.2197C26.0462 15.1833 25.9755 15.1538 25.8882 15.1538H25.7877V14.7365H25.8882C25.9755 14.7365 26.0462 14.707 26.0462 14.6706V14.657C26.0462 14.6206 25.9755 14.5911 25.8882 14.5911H25.7877V14.1738H25.8882C25.9755 14.1738 26.0462 14.1443 26.0462 14.1079V14.0943C26.0462 14.0579 25.9755 14.0284 25.8882 14.0284H25.7877V13.6111H25.8882C25.9755 13.6111 26.0462 13.5816 26.0462 13.5452V13.5316C26.0462 13.4952 25.9755 13.4657 25.8882 13.4657H25.7877V13.0484H25.8882C25.9755 13.0484 26.0462 13.0189 26.0462 12.9825V12.9689C26.0462 12.9325 25.9755 12.903 25.8882 12.903H25.7877V12.6289H24.5308V12.9029H24.4303C24.3431 12.9029 24.2723 12.9324 24.2723 12.9688V12.9825C24.2723 13.0189 24.3431 13.0484 24.4303 13.0484H24.5308V13.4656H24.4303C24.3431 13.4656 24.2723 13.4951 24.2723 13.5315V13.5452C24.2723 13.5816 24.3431 13.611 24.4303 13.611H24.5308V14.0283H24.4303C24.3431 14.0283 24.2723 14.0578 24.2723 14.0942V14.1078C24.2723 14.1442 24.3431 14.1737 24.4303 14.1737H24.5308V14.591H24.4303C24.3431 14.591 24.2723 14.6205 24.2723 14.6569V14.6705C24.2723 14.7069 24.3431 14.7364 24.4303 14.7364H24.5308V15.1537H24.4303C24.3431 15.1537 24.2723 15.1832 24.2723 15.2196V15.2332C24.2723 15.2696 24.3431 15.2991 24.4303 15.2991H24.5308V15.7164H24.4303C24.3431 15.7164 24.2723 15.7459 24.2723 15.7823V15.7959C24.2723 15.8323 24.3431 15.8618 24.4303 15.8618H24.5308V16.2791H24.4303C24.3431 16.2791 24.2723 16.3086 24.2723 16.345V16.3586C24.2723 16.395 24.3431 16.4245 24.4303 16.4245H24.5308V16.8418H24.4303C24.3431 16.8418 24.2723 16.8713 24.2723 16.9077V16.9213C24.2723 16.934 24.2814 16.9458 24.2963 16.9558C24.6396 16.9962 24.9646 17.042 25.2669 17.0933L25.2669 17.0933Z"
          fill="#F8FAFC"
        />
        <path
          d="M19.6753 19.8555C19.6058 19.8164 19.5278 19.7969 19.441 19.7969C19.3543 19.7969 19.2761 19.8163 19.2067 19.8555C19.1372 19.8945 19.0827 19.9491 19.0431 20.0192C19.0034 20.0892 18.9835 20.1677 18.9835 20.2544C18.9835 20.3411 19.0034 20.4197 19.0431 20.4896C19.0827 20.5597 19.1372 20.6143 19.2067 20.6533C19.2761 20.6924 19.3543 20.7119 19.441 20.7119C19.5278 20.7119 19.6059 20.6924 19.6753 20.6533C19.7448 20.6143 19.7993 20.5597 19.839 20.4896C19.8787 20.4196 19.8986 20.3412 19.8986 20.2544C19.8986 20.1676 19.8787 20.0892 19.839 20.0192C19.7993 19.9491 19.7448 19.8946 19.6753 19.8555Z"
          fill="#F8FAFC"
        />
        <path
          d="M17.5089 20.1064C17.5542 20.076 17.5769 20.0317 17.5769 19.9733C17.5769 19.915 17.5542 19.8689 17.5089 19.8385C17.4637 19.8082 17.3989 19.793 17.3146 19.793H16.9724V20.1519H17.3146C17.3989 20.1519 17.4637 20.1367 17.5089 20.1064Z"
          fill="#F8FAFC"
        />
        <path
          d="M22.2019 20.4168H22.6911L22.4455 19.8477L22.2019 20.4168Z"
          fill="#F8FAFC"
        />
        <path
          d="M17.363 20.3398H16.9724V20.7156H17.363C17.5501 20.7156 17.6437 20.653 17.6437 20.5278C17.6437 20.4025 17.5501 20.3399 17.363 20.3399V20.3398Z"
          fill="#F8FAFC"
        />
        <path
          d="M20.5136 16.6406C16.868 16.6406 13.9126 17.8421 13.9126 19.3242V22.7403H27.1145V19.3242C27.1145 17.8421 24.1592 16.6406 20.5136 16.6406ZM17.7572 20.8124C17.6704 20.8738 17.544 20.9044 17.3779 20.9044H16.7307V19.6025H17.3407C17.4944 19.6025 17.6128 19.6326 17.6959 19.6926C17.779 19.7528 17.8206 19.8356 17.8206 19.9409C17.8206 20.0054 17.8057 20.0624 17.776 20.1121C17.7462 20.1616 17.7053 20.2001 17.6532 20.2274C17.7251 20.251 17.7821 20.2904 17.8243 20.3455C17.8664 20.4007 17.8876 20.4693 17.8876 20.551C17.8876 20.6639 17.8442 20.751 17.7573 20.8124H17.7572ZM18.4342 20.9044H18.1924V19.6025H18.4342V20.9044ZM20.0504 20.5975C19.9896 20.6992 19.9059 20.7789 19.7993 20.8365C19.6926 20.8942 19.573 20.923 19.4403 20.923C19.3077 20.923 19.188 20.8942 19.0814 20.8365C18.9747 20.7788 18.891 20.6989 18.8303 20.5966C18.7695 20.4943 18.7392 20.3799 18.7392 20.2535C18.7392 20.1271 18.7696 20.0127 18.8303 19.9104C18.891 19.8081 18.9747 19.7281 19.0814 19.6705C19.188 19.6128 19.3077 19.584 19.4403 19.584C19.573 19.584 19.6926 19.6129 19.7993 19.6705C19.906 19.7281 19.9896 19.8078 20.0504 19.9094C20.1111 20.0112 20.1415 20.1259 20.1415 20.2535C20.1415 20.3811 20.1111 20.4959 20.0504 20.5975ZM20.6557 20.4878C20.696 20.5573 20.7518 20.6118 20.8232 20.6515C20.8944 20.6912 20.9754 20.711 21.0658 20.711C21.1675 20.711 21.2568 20.6887 21.3337 20.644V20.2386H21.5625V20.7575C21.4955 20.8108 21.4174 20.8518 21.3282 20.8802C21.2389 20.9087 21.1471 20.923 21.0529 20.923C20.9201 20.923 20.8005 20.8942 20.6939 20.8365C20.5873 20.7788 20.5036 20.6992 20.4429 20.5975C20.3821 20.4959 20.3517 20.3812 20.3517 20.2535C20.3517 20.1258 20.3821 20.0111 20.4429 19.9094C20.5036 19.8078 20.5876 19.7281 20.6949 19.6705C20.8021 19.6128 20.9226 19.584 21.0566 19.584C21.1657 19.584 21.2649 19.602 21.3542 19.638C21.4434 19.6739 21.5184 19.7266 21.5793 19.7961L21.4268 19.9448C21.3275 19.8457 21.2079 19.7961 21.0678 19.7961C20.976 19.7961 20.8945 19.8152 20.8232 19.8537C20.752 19.8922 20.6962 19.9461 20.6558 20.0155C20.6155 20.085 20.5954 20.1643 20.5954 20.2536C20.5954 20.3428 20.6155 20.4185 20.6558 20.4879L20.6557 20.4878ZM22.9015 20.9044L22.7713 20.6031H22.1204L21.9921 20.9044H21.7429L22.3288 19.6025H22.5668L23.1546 20.9044H22.9016H22.9015ZM24.2379 20.7315C24.1988 20.7898 24.1396 20.8363 24.0602 20.871C23.9808 20.9056 23.8841 20.923 23.7701 20.923C23.6697 20.923 23.5726 20.9088 23.479 20.8803C23.3853 20.8518 23.3113 20.814 23.2568 20.7668L23.3404 20.579C23.3937 20.6212 23.4591 20.6556 23.5366 20.6822C23.614 20.7089 23.6919 20.7222 23.77 20.7222C23.8667 20.7222 23.9389 20.7067 23.9867 20.6757C24.0344 20.6448 24.0583 20.6038 24.0583 20.553C24.0583 20.5158 24.045 20.4851 24.0184 20.461C23.9917 20.4367 23.9579 20.4179 23.917 20.4042C23.8761 20.3906 23.8203 20.3751 23.7496 20.3577C23.6504 20.3342 23.5701 20.3106 23.5087 20.287C23.4473 20.2635 23.3946 20.2266 23.3506 20.1763C23.3065 20.1261 23.2845 20.0582 23.2845 19.9727C23.2845 19.9008 23.3041 19.8354 23.3431 19.7765C23.3822 19.7176 23.4411 19.6708 23.5198 19.6361C23.5986 19.6013 23.695 19.584 23.809 19.584C23.8884 19.584 23.9665 19.594 24.0433 19.6138C24.1202 19.6337 24.1866 19.6622 24.2423 19.6994L24.1661 19.8872C24.109 19.8537 24.0496 19.8283 23.9875 19.811C23.9256 19.7936 23.8654 19.785 23.8071 19.785C23.7116 19.785 23.6406 19.8011 23.5941 19.8333C23.5476 19.8656 23.5243 19.9083 23.5243 19.9617C23.5243 19.9989 23.5376 20.0292 23.5643 20.0528C23.5909 20.0764 23.6248 20.0949 23.6656 20.1086C23.7065 20.1222 23.7624 20.1378 23.8331 20.1551C23.9299 20.1775 24.0091 20.2007 24.0712 20.2249C24.1331 20.2491 24.1862 20.2859 24.2302 20.3356C24.2743 20.3851 24.2963 20.4521 24.2963 20.5364C24.2963 20.6083 24.2767 20.6735 24.2377 20.7317L24.2379 20.7315Z"
          fill="#F8FAFC"
        />
        <path
          d="M28.1322 24.0978H13.0919V23.3097C13.0919 23.2767 13.1087 23.25 13.1295 23.25H28.0947C28.1154 23.25 28.1322 23.2767 28.1322 23.3097V24.0978H28.1322Z"
          fill="#F8FAFC"
        />
      </g>
      <defs>
        <filter
          id="filter0_ddd_12584_35655"
          x="0.925184"
          y="0.264553"
          width="38.9961"
          height="38.9963"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.534193" />
          <feGaussianBlur stdDeviation="2.13677" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.219608 0 0 0 0 0.262745 0 0 0 0 0.419608 0 0 0 0.12 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_12584_35655"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1.60258" />
          <feGaussianBlur stdDeviation="1.06839" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.219608 0 0 0 0 0.262745 0 0 0 0 0.419608 0 0 0 0.14 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_12584_35655"
            result="effect2_dropShadow_12584_35655"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1.06839"
            operator="erode"
            in="SourceAlpha"
            result="effect3_dropShadow_12584_35655"
          />
          <feOffset dy="1.60258" />
          <feGaussianBlur stdDeviation="0.80129" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.219608 0 0 0 0 0.262745 0 0 0 0 0.419608 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_dropShadow_12584_35655"
            result="effect3_dropShadow_12584_35655"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect3_dropShadow_12584_35655"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_12584_35655">
          <rect
            width="14.6626"
            height="11.5758"
            fill="white"
            transform="translate(13.0919 12.4258)"
          />
        </clipPath>
      </defs>
    </svg>
  </Box>
);
